import { css } from '@utils/css';

const dialog = css`
  margin: 0;
  padding: 0;

  height: auto;
  width: auto;

  border: none;
`;

export { dialog };
//# sourceMappingURL=dialog.js.map
